var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-active-element',{staticClass:"ui-status-checkbox",class:_vm.statusName,on:{"click":_vm.onClick}},[_c('span',{staticClass:"ui-status-checkbox_rect"},[(_vm.localValue)?_c('app-icon',{attrs:{"name":_vm.ICON_NAMES.CHECK_MARK}}):_vm._e()],1),_c('span',{staticClass:"ui-status-checkbox_text"},[_vm._v(_vm._s(_vm.localLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }